<template>
  <div>
    <div class="mt-n2 mb-1">
      <v-icon large class="mb-1" @click="goBack()">mdi-chevron-left</v-icon>
      <span class="my-auto title font-weight-bold">Unlock Premium Trades</span>
    </div>
    <div v-if="isLoading" class="d-flex justify-center align-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <div class="mb-8" v-for="item in trades" :key="item.id">
      <div class="position-relative">
        <TradeCard :trade_data="item" :ref="`${item.id}`"> </TradeCard>
        <!-- Lock the card for unsubscribe user -->
        <v-card
          v-if="!item.is_unlocked"
          class="overlay-card d-flex flex-column justify-center align-center"
        >
          <v-card-text>
            <div class="d-flex justify-center align-center mt-6">
              <div>
                <img :src="lock" />
              </div>
              <div class="lock-text">
                This trade is locked, Unlock to have a <br />
                look
              </div>
            </div>
            <div class="banking_div mx-auto my-4">
              <div class="text-center mt-4 black--text">
                <div class="secutity-name">{{ item.security_industry }}</div>
              </div>

              <div class="d-flex justify-center align-center my-4 equal-widths">
                <div class="text-center">
                  <div>Posted On</div>
                  <div class="black--text">
                    {{ formatTradeDate(item.created) }}
                  </div>
                </div>
                <v-divider vertical class="mx-3"></v-divider>
                <div class="text-center">
                  <div>Duration</div>
                  <div class="black--text">{{ item.duration_name }}</div>
                </div>
                <v-divider vertical class="mx-3"></v-divider>
                <div class="text-center">
                  <div>Profit Potential</div>
                  <div class="green--text">{{ item.pl_percent }}%</div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <div class="text-center">
              <v-btn
                color="primary text-none"
                style="cursor: pointer"
                @click="unlockTrade(item)"
                >Unlock for 100
                <img
                  class="ml-1 mb-1"
                  src="@/components/gamification/coin_icon.svg"
              /></v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import TradeCard from "@/components/TradeCard.vue";
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
export default {
  components: {
    TradeCard,
  },
  data() {
    return {
      lock: require("@/assets/images/lock.png"),
      trades: [],
      isLoading: true,
    };
  },
  mounted() {
    this.getPremiunTradeList();
  },
  methods: {
    getPremiunTradeList() {
      const onSuccess = (res) => {
        this.isLoading = false;
        this.trades = res.data.result;
      };
      const onFailure = () => {};
      const user_id = localStorage.getItem("user_id");
      const url = `${apiUrl.GET_PREMIUN_TRADE_LIST}/${user_id}/1`;
      newAxios("get", url, {
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    unlockTrade(item) {
      const onSuccess = () => {
        this.getPremiunTradeList();
      };
      const onFailure = () => {};
      const user_id = localStorage.getItem("user_id");
      let data = {};
      data["user"] = Number(user_id);
      data["trade"] = item.id;
      newAxios("post", apiUrl.UNLOCK_TRADE, {
        data,
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    goBack() {
      this.$router.go(-1); // Navigates to the previous page in history
    },
    formatTradeDate(dateString) {
      const date = new Date(dateString);

      const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
      const dateOptions = { day: "2-digit", month: "long" };

      const time = date.toLocaleTimeString("en-US", timeOptions);
      const day = date.toLocaleDateString("en-US", dateOptions);

      return `${time} ${day}`;
    },
  },
};
</script>

<style scoped>
.lock-text {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 27.32px;
  color: #333333;
}
.secutity-name {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 27.32px;
  color: #333333;
}
.heading {
  font-family: Avenir;
  font-size: 22px;
  line-height: 27.32px;
  color: #333333;
}

.banking_div {
  border: 1px solid #e4e4e4;
  border-radius: 12px;
  width: 450px;
}

.position-relative {
  position: relative;
  z-index: 4;
}

.overlay-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px);
  background: rgba(255, 255, 255, 0.8);
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.overlay-card .v-card-text,
.overlay-card .v-card-actions {
  pointer-events: all;
}
@media (max-width: 600px) {
  .banking_div {
    width: 280px;
  }
  .lock-text {
    font-family: Avenir;
    font-size: 14px;
    font-weight: 800;
    line-height: 18px;
    color: #333333;
  }
}
</style>
